import React from 'react';

const instructionalPart2Description = (
  <div>
    <h3 className="vads-u-font-size--h4">Fill in employer details</h3>
    <p>
      Put the employer’s name and address in <strong>Box 1.</strong>
    </p>
    <img src="/img/part2-image.png" alt="Box 1" />
  </div>
);

export default instructionalPart2Description;
